import { Trans, useLingui } from "@lingui/react/macro";
import { Heading } from "@medoma/components/Heading/Heading";
import { Text } from "@medoma/components/Text/Text";
import { GoBackLink } from "@/routes/profile/goBackLink";
import ShareExternalLinkIcon from "@medoma/components/icons/ShareExternalLinkIcon";
import { Link } from "@medoma/components/Link/Link";

export const About = () => {
  const { t } = useLingui();
  return (
    <>
      <GoBackLink />
      <Heading level="h1" margin="top">
        <Trans>Om appen</Trans>
      </Heading>
      <Heading level="h2" margin="top-and-bottom">
        <Trans>Integritetspolicy</Trans>
      </Heading>
      <Text element="p">
        <Trans>
          För att läsa om hur vi hanterar din integritet, kan du ta del av vår
          integritetspolicy.
        </Trans>
      </Text>
      <Text element="p">
        <Link to={t`https://www.medoma.com/se/privacy-policy`} type="external">
          <ShareExternalLinkIcon />
          <Trans>Integritetspolicy</Trans>
        </Link>
      </Text>
      <Heading level="h2" margin="top-and-bottom">
        <Trans>Hjälp med appen</Trans>
      </Heading>
      <Text element="p">
        <Trans>
          Kontakta din vårdgivare om du behöver hjälp med appen eller har
          förslag på förbättringar.{" "}
        </Trans>
      </Text>
    </>
  );
};
